import React, { useState } from "react";
import { supabase } from "../../supabaseClient";

const AdminSettingsPassword = ({ onBack }) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handlePasswordChangeSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    if (newPassword !== confirmPassword) {
      setError("Lozinke se ne podudaraju.");
      return;
    }

    if (newPassword.length < 6) {
      setError("Nova lozinka mora imati najmanje 6 znakova.");
      return;
    }

    setLoading(true);

    try {
      const { error: updateError } = await supabase.auth.updateUser({
        password: newPassword,
      });

      if (updateError) throw updateError;

      setMessage("Lozinka je uspješno promijenjena!");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      setError(err.message || "Došlo je do pogreške pri promjeni lozinke.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-settings-subpage">
      <div className="admin-subpage-header">
        <button type="button" className="back-btn" onClick={onBack}>
          <i className="fi fi-rs-angle-small-left"></i> Natrag
        </button>
      </div>
      <h3>Promjena lozinke</h3>
      <div className="admin-form-card">
        <p className="subpage-desc">
          Ovdje možete direktno promijeniti svoju lozinku za pristup
          administratorskom sučelju.
        </p>

        <form onSubmit={handlePasswordChangeSubmit}>
          <div className="input-field">
            <label>Nova lozinka</label>
            <div className="password-container">
              <input
                type={showPassword ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <span onClick={() => setShowPassword(!showPassword)}>
                <i
                  className={
                    showPassword ? "fi fi-rs-eye" : "fi fi-rs-crossed-eye"
                  }
                ></i>
              </span>
            </div>
          </div>

          <div className="input-field">
            <label>Potvrdi novu lozinku</label>
            <div className="password-container">
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <span
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                <i
                  className={
                    showConfirmPassword
                      ? "fi fi-rs-eye"
                      : "fi fi-rs-crossed-eye"
                  }
                ></i>
              </span>
            </div>
          </div>

          {error && <p className="error-msg">{error}</p>}
          {message && <p className="success-msg">{message}</p>}

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Spremanje..." : "Promijeni lozinku"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminSettingsPassword;
